import { type IIconsVector } from 'shared/ui'

export enum CrmEnum {
  hubSpot = 'hubSpot',
  activeCampaign = 'activeCampaign',
  keap = 'keap',
  salesforce = 'salesforce',
  pipedrive = 'pipedrive',
  none = 'none',
  other = 'other',
}

export type ICrm = {
  id: CrmEnum
  name: string
  value: string
  icon: IIconsVector
}

export const CRMS: ICrm[] = [
  {
    id: CrmEnum.hubSpot,
    value: 'HubSpot',
    name: 'HubSpot',
    icon: 'hubspot',
  },
  {
    id: CrmEnum.activeCampaign,
    value: 'ActiveCampaign',
    name: 'ActiveCampaign',
    icon: 'activecampaign',
  },
  {
    id: CrmEnum.keap,
    value: 'Keap (Infusionsoft)',
    name: 'Keap',
    icon: 'infusionsoft',
  },
  {
    id: CrmEnum.salesforce,
    value: 'Salesforce',
    name: 'Salesforce',
    icon: 'salesforce',
  },
  {
    id: CrmEnum.pipedrive,
    value: 'Pipedrive',
    name: 'Pipedrive',
    icon: 'pipedrive',
  },
  {
    id: CrmEnum.none,
    value: 'None',
    name: 'None',
    icon: 'block',
  },
  {
    id: CrmEnum.other,
    value: 'Other',
    name: 'Other',
    icon: 'lightning2',
  },
]
